import * as React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";

import { DashboardIcon } from "@teamprevent/common/dashboard";

interface AllProps {
}

export class All extends React.Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    public render() {
        return (
            <div className="dashboard">
                <Grid columns="4" doubling stackable centered>
                    <Grid.Column>
                        <DashboardIcon
                            href="/assessmentandwellbeing/newstressriskassessment"
                            icon="/assets/create-new-stress-risk-assessment.svg"
                            label="Create New Stress Risk Assessment"
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <DashboardIcon
                            href="/assessmentandwellbeing/myresults"
                            icon="/assets/my-assessments.svg"
                            label="View Results"
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <DashboardIcon
                            href="/assessmentandwellbeing/overview"
                            icon="/assets/Results.svg"
                            label="Overview"
                        />
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default connect()(All);
